import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, Home, MessageCircle } from 'lucide-react';
import Footer from '../components/Footer';

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex flex-col justify-between">
            <Helmet>
                <title>Pagina no encontrada | Catalogo Essen Digital</title>
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            {/* Header */}
            <header className="bg-white/80 backdrop-blur-lg shadow-sm border-b border-purple-100 py-6">
                <div className="max-w-7xl mx-auto px-4 flex items-center justify-center gap-3">
                    <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-2 rounded-lg">
                        <span className="text-white font-bold text-xl">S</span>
                    </div>
                    <span className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                        Mi Essen
                    </span>
                </div>
            </header>

            {/* Content */}
            <main className="max-w-md mx-auto px-6 py-16 text-center flex flex-col items-center justify-center flex-grow">
                <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border border-gray-100 w-full hover:scale-[1.02] transition-transform duration-300">
                    <div className="bg-red-50 w-20 h-20 rounded-full flex items-center justify-center mb-6 mx-auto border border-red-100">
                        <AlertCircle className="w-10 h-10 text-red-500 animate-pulse" />
                    </div>

                    <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
                        Catálogo No Encontrado
                    </h1>
                    
                    <p className="text-gray-500 text-sm mb-6">
                        Error 404
                    </p>

                    <p className="text-gray-600 mb-8 leading-relaxed">
                        El número de Essen ingresado no corresponde a un catálogo activo. Por favor, verificá que el enlace sea correcto o ponete en contacto con tu asesor/a.
                    </p>

                    <div className="flex flex-col gap-4">
                        <button
                            onClick={() => navigate('/')}
                            className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3.5 rounded-full font-bold text-base hover:from-purple-700 hover:to-pink-700 transition-all shadow-lg hover:shadow-xl active:scale-95"
                        >
                            <Home className="w-5 h-5" />
                            Ir al Inicio
                        </button>

                        <a
                            href="https://wa.me/5492616815848?text=Hola!%20Tengo%20dudas%20con%20el%20acceso%20a%20un%20catálogo%20Essen"
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center justify-center gap-3 bg-white text-gray-700 border border-gray-200 px-6 py-3.5 rounded-full font-bold text-base hover:bg-gray-50 transition-all shadow-sm hover:shadow active:scale-95"
                        >
                            <MessageCircle className="w-5 h-5 text-green-500" />
                            Soporte por WhatsApp
                        </a>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default NotFoundPage;
